import type { TerminalDevice } from './types';

function seenAt(device: TerminalDevice): number {
  return device.lastSeenAt ? Date.parse(device.lastSeenAt) || 0 : 0;
}

export function pickTerminalDevice(
  devices: TerminalDevice[],
): TerminalDevice | null {
  const ranked = [...devices].sort((a, b) => {
    if (a.isConnected !== b.isConnected) {
      return a.isConnected ? -1 : 1;
    }
    return seenAt(b) - seenAt(a);
  });
  return ranked[0] ?? null;
}

export interface ResolvedTerminalDevice {
  device: TerminalDevice | null;
  isExplicit: boolean;
}

export function resolveTerminalDevice(
  devices: TerminalDevice[],
  preferredDeviceId: string | null,
): ResolvedTerminalDevice {
  const preferred = preferredDeviceId
    ? devices.find((device) => device.deviceId === preferredDeviceId)
    : undefined;
  if (preferred) {
    return { device: preferred, isExplicit: true };
  }
  return { device: pickTerminalDevice(devices), isExplicit: false };
}
